<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="contents">
        <el-form
          class="demo-cityForm"
          label-width="170px"
          ref="refCityForm"
          v-loading="dialogLoading"
          :model="cityForm"
          :rules="cityRules"
        >
          <!-- 非升仓表单 start -->
          <el-form-item label="城市仓名称" prop="name">
            <div>
              <el-input
                v-model="cityForm.name"
                placeholder="请输入城市仓名称"
                clearable
                :disabled="closeDisable"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="集配业务中心" prop="business_id">
            <div>
              <el-select
                v-model="cityForm.business_id"
                clearable
                :disabled="closeDisable"
                placeholder="选择业务中心"
                @change="changeBusinessId"
              >
                <el-option
                  @click.native="morning_time = item.morning_time"
                  v-for="item in logisticsList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="城市仓类型" prop="logistics_type">
            <div>
              <el-select
                v-model="cityForm.logistics_type"
                :disabled="isEdit || closeDisable"
                clearable
                placeholder="选择城市仓类型"
                @change="changeLogisticsType"
              >
                <el-option
                  v-for="item of logisticsTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item v-if="isEdit" label="自提点数量" prop="delivery_number">
            <div>
              <el-input
                :disabled="true"
                v-model="cityForm.delivery_number"
                placeholder="请输入自提点数量"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="截单时间" prop="dateTime">
            <div class="d-flex a-center">
              <div class="d-flex a-center">
                <div>
                  <el-time-picker
                    :disabled="closeDisable"
                    v-model="cityForm.startTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="开始时间"
                  >
                  </el-time-picker>
                </div>
                <div>—</div>
                <div>
                  <el-time-picker
                    :disabled="closeDisable"
                    v-model="cityForm.endTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="结束时间"
                  >
                  </el-time-picker>
                </div>
              </div>
              <div style="margin-left: 20px">
                {{ Timename() }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="titlename()"
                  placement="top-start"
                >
                  <el-button type="text" style="color: #000">
                    <i class="el-icon-warning-outline"></i
                  ></el-button>

                  <!-- <el-button
                    type="primary"
                    icon="el-icon-warning-outline"
                    circle
                  ></el-button> -->
                </el-tooltip>
              </div>
            </div>
          </el-form-item>
          <!-- 非升仓表单 end -->

          <!-- 升仓后的表单 start -->
          <template>
            <el-form-item label="账号昵称">
              <div>
                <el-input
                  v-model="cityForm.nickname"
                  placeholder="请输入账号昵称"
                  clearable
                  :disabled="closeDisable"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="登录账号" prop="account_number">
              <div>
                <!--   :disabled="true" -->
                <el-input
                  v-model="cityForm.account_number"
                  placeholder="请输入登录账号"
                  clearable
                  :disabled="isEdit || closeDisable"
                >
                  <el-button
                    type="text"
                    slot="suffix"
                    :disabled="!businessUserId || closeDisable"
                    @click="onHandleResetPassword"
                    >重置密码</el-button
                  >
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="密码" prop="password" v-if="!isEdit">
              <div>
                <el-input
                  type="password"
                  :disabled="closeDisable"
                  v-model="cityForm.password"
                  placeholder="请输入密码"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="客服电话" prop="service_mobile">
              <div>
                <el-input
                  v-model="cityForm.service_mobile"
                  :maxlength="11"
                  :disabled="closeDisable"
                  placeholder="请输入客服电话"
                  clearable
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item label="提现银行卡" prop="card_code">
              <div>
                <el-input
                  :disabled="closeDisable || isEdit"
                  v-model="cityForm.card_code"
                  placeholder="请输入提现银行卡"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="所属银行" prop="bank_code">
              <div>
                <el-select
                  @change="
                    depositList = [];
                    cityForm.bank_deposit = '';
                  "
                  v-model="cityForm.bank_code"
                  clearable
                  filterable
                  :disabled="closeDisable || isEdit"
                  placeholder="选择所属银行"
                >
                  <el-option
                    @click.native="cityForm.bank_name = item.bank_name"
                    v-for="item in bankList"
                    :key="item.bank_code"
                    :label="item.bank_name"
                    :value="item.bank_code"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="开户行" prop="bank_deposit">
              <div>
                <el-select
                  :disabled="closeDisable || isEdit"
                  :remote-method="ajaxGetBranchList"
                  :loading="depositLoading"
                  v-model="cityForm.bank_deposit"
                  clearable
                  filterable
                  remote
                  placeholder="选择开户行"
                >
                  <el-option
                    @click.native="cityForm.deposit_code = item.code"
                    v-for="item in depositList"
                    :key="item.code"
                    :label="item.branch_name"
                    :value="item.branch_name"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="持卡人身份证国徽页" prop="idcard_a">
              <el-upload
                action="#"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_a.length || !idcard_a }"
                :file-list="idcard_a"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_a')"
                :before-remove="() => onHandleDeleteFile('idcard_a')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="持卡人身份证人像页" prop="idcard_b">
              <el-upload
                action="#"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: idcard_b.length || !idcard_b }"
                :file-list="idcard_b"
                list-type="picture-card"
                :http-request="(data) => onHandleUploadFile(data, 'idcard_b')"
                :before-remove="() => onHandleDeleteFile('idcard_b')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="持卡人姓名" prop="idcard_name">
              <div>
                <el-input
                  :disabled="closeDisable || isEdit"
                  v-model="cityForm.idcard_name"
                  placeholder="请输入持卡人姓名"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <!-- 新增持卡人身份证号 start -->
            <el-form-item label="持卡人身份证号" prop="idcard_code">
              <div>
                <el-input
                  :disabled="closeDisable || isEdit"
                  v-model="cityForm.idcard_code"
                  placeholder="请输入持卡人身份证号"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <!-- 新增持卡人身份证号 end -->
            <el-form-item label="预留电话" prop="bank_mobile">
              <div>
                <el-input
                  :disabled="closeDisable || isEdit"
                  v-model="cityForm.bank_mobile"
                  placeholder="请输入预留电话"
                  maxlength="11"
                  clearable
                ></el-input>
              </div>
            </el-form-item>

            <!-- 新增城市仓区域经理字段 start -->
            <el-form-item label="服务区域" prop="area_list">
              <div class="d-flex a-center">
                <div class="mr-15">
                  <el-select
                    :disabled="closeDisable"
                    v-model="cityForm.province_code"
                    clearable
                    filterable
                    placeholder="选择省"
                    @change="changeProvinceList"
                  >
                    <el-option
                      v-for="item in province_list"
                      :key="item.area_code"
                      :label="item.name"
                      :value="item.area_code"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="mr-15">
                  <el-select
                    :disabled="closeDisable"
                    v-model="cityForm.city_code"
                    clearable
                    filterable
                    placeholder="选择市"
                    @change="changeCityList"
                  >
                    <el-option
                      v-for="item in city_list"
                      :key="item.area_code"
                      :label="item.name"
                      :value="item.area_code"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div>
                  <el-select
                    :disabled="closeDisable"
                    v-model="cityForm.area_list"
                    clearable
                    filterable
                    multiple
                    placeholder="选择区"
                  >
                    <el-option
                      v-for="item in district_list"
                      :key="item.area_code"
                      :label="item.name"
                      :value="item.area_code"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="区域经理" prop="regional_manager_id">
              <el-select
                :disabled="closeDisable"
                v-model="cityForm.regional_manager_id"
                clearable
                filterable
                placeholder="选择区域经理"
              >
                <el-option
                  v-for="item in managerListData"
                  :key="item.id"
                  :label="item.fullname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域总人口" prop="regional_user_num">
              <div class="d-flex a-center">
                <el-input
                  :disabled="closeDisable"
                  v-model="cityForm.regional_user_num"
                  placeholder="请输入区域总人口"
                  clearable
                  @blur="
                    () => {
                      cityForm.regional_user_num =
                        cityForm.regional_user_num == 0
                          ? ''
                          : cityForm.regional_user_num;
                    }
                  "
                >
                </el-input>
                <div
                  style="color: #333333; width: 80px; text-align: left"
                  class="ml10"
                >
                  万人
                </div>
              </div>
            </el-form-item>
            <el-form-item label="仓覆盖人口" prop="coverage_user_num">
              <div class="d-flex a-center">
                <el-input
                  :disabled="closeDisable"
                  v-model="cityForm.coverage_user_num"
                  placeholder="请输入仓覆盖人口"
                  clearable
                  @blur="
                    () => {
                      cityForm.coverage_user_num =
                        cityForm.coverage_user_num == 0
                          ? ''
                          : cityForm.coverage_user_num;
                    }
                  "
                >
                </el-input>
                <div
                  style="color: #333333; width: 80px; text-align: left"
                  class="ml10"
                >
                  万人
                </div>
              </div>
            </el-form-item>
            <el-form-item label="签约状态" prop="contract_status">
              <div>
                <el-select
                  :disabled="closeDisable"
                  v-model="cityForm.contract_status"
                  clearable
                  filterable
                  placeholder="选择签约状态"
                >
                  <el-option
                    v-for="item in SIGN_STATUS_ENUM"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="xx天不发车停车整改" prop="stop_logistics_day">
              <div class="d-flex a-center">
                <el-input
                  :disabled="closeDisable"
                  v-model="cityForm.stop_logistics_day"
                  placeholder="请输入"
                  clearable
                >
                </el-input>
                <div
                  style="color: #333333; width: 80px; text-align: left"
                  class="ml10"
                >
                  天
                </div>
              </div>
            </el-form-item>
            <el-form-item label="保证金" prop="earnest_money">
              <div class="d-flex a-center">
                <el-input
                  :disabled="closeDisable"
                  v-model="cityForm.earnest_money"
                  placeholder="请输入保证金"
                  clearable
                  @blur="BlurEarnestMoney()"
                >
                </el-input>
                <div
                  style="color: #333333; width: 80px; text-align: left"
                  class="ml10"
                >
                  元
                </div>
              </div>
            </el-form-item>
            <el-form-item label="保证金转账记录" prop="earnest_url">
              <el-upload
                action="#"
                v-loading="uploadLoading"
                :on-preview="onHandlePictureCardPreview"
                :class="{ hide: earnest_url.length || !earnest_url }"
                :file-list="earnest_url"
                list-type="picture-card"
                :http-request="
                  (data) => onHandleUploadFile(data, 'earnest_url')
                "
                :before-remove="() => onHandleDeleteFile('earnest_url')"
                :limit="1"
              >
                <i slot="trigger" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <!-- 新增城市仓区域经理字段 end -->
            <el-form-item label="运距" prop="shipment_distance">
              <div>
                <el-input
                  :disabled="isEdit || closeDisable"
                  class="distance-style"
                  v-model="cityForm.shipment_distance"
                  @blur="
                    () =>
                      (cityForm.shipment_distance = utilsTool.filterUnNumber(
                        cityForm.shipment_distance
                      ))
                  "
                  placeholder="请输入运距"
                  clearable
                ></el-input>
                公里
              </div>
            </el-form-item>
            <div class="d-flex mb-10">
              <div style="width: 170px; text-align: right">在途时间：</div>
              {{ trans_time }}
            </div>
            <div class="d-flex mb-10">
              <div style="width: 170px; text-align: right">定位地址：</div>
              {{ address }}
            </div>
          </template>
          <!-- 升仓后的表单 end -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          v-if="!closeDisable"
          type="primary"
          :loading="submitLoading"
          @click="onHandleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <!-- 登录密码已重置 弹窗 start -->
    <el-dialog
      title="登录密码已重置"
      :visible.sync="newPassword"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClosePassword"
      width="30%"
      class="dialog"
      center
    >
      <div class="contents">
        <div class="mb-10">登录账户：{{ cityForm.account_number }}</div>
        <div class="mb-25 d-flex a-center">
          重置密码：{{ newPasswordText }}
          <div style="margin-left: 10px">
            <el-button type="primary" @click="onHandleCopy">复制</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClosePassword">取 消</el-button>
        <el-button type="primary" @click="onHandleClosePassword">
          关闭
        </el-button>
      </span>
    </el-dialog>
    <!-- 登录密码已重置 弹窗 end -->
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import utilsTool from "@/utils/tools/tool";
import { formatDate } from "@/utils//tools/date.js";
import {
  LOGISTICS_TYPE_ENUM,
  UPGRADE_POSITION_ENUM,
  SIGN_STATUS_ENUM,
} from "../../utils/enum/index";
import tool from "@/utils/tools/tool";
import {
  postAreaChildList,
  postGetIdcardInfo,
  postRegionalManagerSelectList,
} from "@/api/general/manager.js";

export default {
  name: "EditStoreDialog",
  props: {
    /**
     * 集配中心列表
     */
    logisticsList: {
      type: Array,
      default: () => [],
    },
    // managerList: {
    //   type: Array,
    //   default: () => [],
    // },
    /**
     * 银行列表
     */
    bankList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tool,
      newPassword: false, // 重置密码弹窗
      newPasswordText: "", // 重置后的密码
      dialogVisible: false,
      dialogLoading: false,
      utilsTool,
      titleMap: {
        add: {
          value: "add",
          label: "新增城市仓",
        },
        edit: {
          value: "edit",
          label: "编辑城市仓",
        },
      },
      morning_time: "",
      dialogTitle: "",
      UPGRADE_POSITION_ENUM,
      SIGN_STATUS_ENUM,
      loadImage: null,
      depositLoading: false,
      depositList: [], // 开户行列表
      idcard_a: [], // 身份证国徽图片
      idcard_b: [], // 身份证人像图片
      earnest_url: [], // 保证金证明图
      province_list: [], // 服务区域省
      city_list: [], //  服务区域市
      district_list: [], //  服务区域区
      // 城市仓参数
      cityForm: {
        name: "", // 城市仓名称
        business_id: "", // 集配中心id
        logistics_type: LOGISTICS_TYPE_ENUM.common.value, // 城市仓类型
        delivery_number: "", // 自提点数量
        startTime: "", // 截单开始时间
        endTime: "", // 截单结束时间
        nickname: "", // 账号昵称
        password: "", // 账号密码
        account_number: "", // 登录账号
        bank_mobile: "", // 预留电话
        service_mobile: "", // 客服电话

        card_code: "", // 提现银行卡
        bank_code: "", // 所属银行code
        bank_name: "", // 所属银行名称
        bank_deposit: "", // 开户行
        deposit_code: "", //开户行code
        idcard_name: "", // 持卡人
        idcard_code: "", // 持卡人身份证号

        province_code: "", // 服务区域省
        city_code: "", //  服务区域市
        area_list: [], //  服务区域区

        idcard_a: "", // 身份证国徽页
        idcard_b: "", // 身份证人像图片

        regional_manager_id: "", //所属区域经理
        regional_user_num: "", //区域人口
        coverage_user_num: "", //覆盖人口
        contract_status: "", //签约状态
        stop_logistics_day: LOGISTICS_TYPE_ENUM.common.day, // 停仓整改时间
        earnest_money: "", //保证金
        earnest_url: "", //保证金证明图
        shipment_distance: "", // 运距
      },
      cityFormClone: {}, // 拷贝一份数据，用于初始化
      address: "", // 定位地址展示
      trans_time: "", //在途时间
      logisticsBusinessId: "", // 城市仓id
      uploadLoading: false, // 上传loading
      submitLoading: false, // 提交按钮禁用
      logisticsTypeList: Object.values(LOGISTICS_TYPE_ENUM), // 城市仓类型列表
      upgradePosition: UPGRADE_POSITION_ENUM.common.value, // 是否已升仓
      // 表单校验
      cityRules: {
        name: [
          {
            required: true,
            message: "请输入城市仓名称",
            trigger: ["blur", "change"],
          },
        ],
        business_id: [
          { required: true, message: "请选择集采业务中心", trigger: "change" },
        ],
        logistics_type: [
          { required: true, message: "请选择城市仓类型", trigger: "change" },
        ],
        /** 时间校验 */
        dateTime: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              const { startTime, endTime } = this.cityForm;
              if (!startTime || !endTime) {
                callback(new Error("截单时间须填完整！"));
              }
              // 将时间转换成时间戳，比较大小
              let start = `${formatDate()} ${startTime}:00`;
              let end = `${formatDate()} ${endTime}:00`;
              const min = new Date(start).getTime();
              const max = new Date(end).getTime();
              // console.log("🆒 dateTime", min, max);
              if (min > max) {
                callback(new Error("结束时间不得早于开始时间！"));
              }
              callback();
            },
          },
        ],
        account_number: [
          {
            required: true,
            message: "请输入登录账号",
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur", "change"],
          },
        ],
        card_code: [
          {
            required: true,
            message: "请输入提现银行卡",
            trigger: ["blur", "change"],
          },
        ],
        bank_code: [
          {
            required: true,
            message: "请选择所属银行",
            trigger: ["blur", "change"],
          },
        ],
        bank_deposit: [
          {
            required: true,
            message: "请输入开户行",
            trigger: ["blur", "change"],
          },
        ],
        idcard_name: [
          {
            required: false,
            message: "请输入持卡人",
            trigger: ["blur", "change"],
          },
        ],
        idcard_code: [
          {
            required: false,
            message: "请输入持卡人身份证号",
            trigger: ["blur", "change"],
          },
        ],

        idcard_a: [
          {
            required: true,
            message: "请上传身份证国徽页图片",
            trigger: ["blur", "change"],
          },
        ],
        idcard_b: [
          {
            required: true,
            message: "请上传身份证人像页图片",
            trigger: ["blur", "change"],
          },
        ],
        regional_manager_id: [
          {
            required: true,
            message: "请选择区域经理",
            trigger: ["blur", "change"],
          },
        ],
        regional_user_num: [
          {
            required: true,
            message: "请输入区域总人口",
            trigger: ["blur", "change"],
          },
        ],
        coverage_user_num: [
          {
            required: true,
            message: "请输入仓覆盖人口",
            trigger: ["blur", "change"],
          },
        ],
        contract_status: [
          {
            required: true,
            message: "请选择签约状态",
            trigger: ["blur", "change"],
          },
        ],
        earnest_money: [
          {
            required: true,
            message: "请输入保证金",
            trigger: ["blur", "change"],
          },
        ],
        earnest_url: [
          {
            required: false,
            message: "请上传保证金转账记录",
            trigger: ["blur", "change"],
          },
        ],
        /** 预留电话 */
        bank_mobile: [
          {
            required: true,
            message: "请输入预留电话",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],
        /** 客服电话 */
        service_mobile: [
          {
            required: true,
            message: "请输入客服电话",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],
        /** 运距 */
        shipment_distance: [
          {
            required: true,
            message: "请输入运距",
            trigger: ["blur", "change"],
          },
        ],
      },
      isEdit: false, // 是否编辑页
      businessUserId: "", // 用户id
      closeDisable: false, // 是否关仓
      managerListData: [], // 区域经理
    };
  },
  methods: {
    BlurEarnestMoney() {
      // 保证金金额为 0 时，保证金转账凭证非必填；大于 0 需必填；
      if (this.cityForm.earnest_money == 0) {
        this.cityForm.earnest_money = 0;
        this.cityRules.earnest_url[0].required = false;
      } else {
        this.cityForm.earnest_money = this.tool.filterUnNumber(
          this.cityForm.earnest_money
        );
        this.cityRules.earnest_url[0].required = true;
      }
      this.$refs.refCityForm.validateField("earnest_url");
    },
    // 修改集配中心id
    changeBusinessId() {
      this.cityForm.regional_manager_id = ""; // 清空选中区域经理
      if (this.cityForm.business_id) {
        this.postAjaxRegionalManagerSelectList();
      } else {
        this.managerListData = [];
      }
    },
    // 区域经理下拉
    async postAjaxRegionalManagerSelectList() {
      try {
        const res = await postRegionalManagerSelectList({
          state: 1, // 启用
          logistic_business_id: this.cityForm.business_id, //集配id
        });
        this.managerListData = res.data;
      } catch (error) {
        console.log(error, "postRegionalManagerSelectList");
      }
    },
    Timename() {
      if (this.cityForm.startTime != "" && this.morning_time) {
        let timshow = this.isTimeBeforeSix(this.cityForm.startTime);
        return timshow ? "早市" : "午市";
      } else {
      }
    },
    titlename() {
      if (JSON.parse(sessionStorage.getItem("userInfo")).business_id == 549) {
        return `截单开始时间在早${this.morning_time}（包括${this.morning_time}）之前为早市； ${this.morning_time}之后为午市；`;
      } else {
        return `截单开始时间在早${this.morning_time}（包括${this.morning_time}）之前为早市； ${this.morning_time}之后为午市；`;
      }
    },
    isTimeBeforeSix(timeStr) {
      const [hours, minutes] = timeStr.split(":").map(Number);
      const targetTime = new Date();
      let arr = "";

      arr = this.morning_time.split(":");

      if (JSON.parse(sessionStorage.getItem("userInfo")).business_id == 549) {
        targetTime.setHours(arr[0], arr[1], 0, 0);
      } else {
        targetTime.setHours(arr[0], arr[1], 0, 0);
      }

      const inputTime = new Date();
      inputTime.setHours(hours, minutes, 0, 0);

      return inputTime.getTime() <= targetTime.getTime();
    },
    /**
     * 复制 重置后的密码
     */
    async onHandleCopy() {
      try {
        const input = document.createElement("input");
        input.value = this.newPasswordText;
        document.body.appendChild(input);
        input.select();
        if (document.execCommand("Copy")) {
          this.$message.success("复制成功");
        } else {
          this.$message.error("复制失败");
        }
        document.body.removeChild(input);
      } catch (err) {
        this.$message.error("error");
      }
    },
    /**
     * 关闭重置密码弹窗
     */
    onHandleClosePassword() {
      this.newPassword = false;
      this.onHandleClose();
    },
    /**
     * 初始化
     */
    onInitData(data, type) {
      console.log(data, "data===");
      // 关仓只查看
      if (type == "close") {
        this.closeDisable = true;
      } else {
        this.closeDisable = false;
      }
      console.log(type, this.closeDisable, "type==");
      this.dialogVisible = true;
      this.managerListData = []; // 新增 区域经理清空 有集配id 才有对应的区域经理
      this.isEdit = false;
      this.dialogTitle = this.titleMap.add.label;
      this.upgradePosition = UPGRADE_POSITION_ENUM.common.value;
      this.idcard_a = [];
      this.idcard_b = [];
      this.earnest_url = [];
      this.cityFormClone = cloneDeep(this.cityForm);
      this.address = data?.address || ""; //定位地址
      this.trans_time = data?.trans_time || ""; // 在途时间
      this.postAreaChildList({});
      if (data?.id) {
        this.morning_time = data.morning_time;
        this.dialogTitle = this.titleMap.edit.label;
        this.isEdit = true;
        this.dialogLoading = true;
        this.onInitEditForm(JSON.parse(JSON.stringify(data)));
        // 编辑城市仓不必填
        this.cityRules.idcard_name[0].required = false;
        this.cityRules.idcard_code[0].required = false;
        // 编辑 保证金有值 不必填
        this.cityRules.earnest_url[0].required =
          Number(data.earnest_money) == 0 ? false : true;
      } else {
        this.cityRules.idcard_name[0].required = true;
        this.cityRules.idcard_code[0].required = true;
        this.cityRules.earnest_url[0].required = false; // 默认不必填
      }
      this.$refs.refCityForm?.clearValidate();
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.cityForm = {
        ...this.cityFormClone,
      };
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },
    /**
     * 初始化编辑页面
     */
    onInitEditForm(data) {
      // 枚举需要的数据
      const {
        name,
        business_id,
        logistics_type,
        delivery_number,
        service_mobile,
        shipment_distance,
        start_time,
        end_time,
        regional_manager_id,
        regional_user_num,
        coverage_user_num,
        stop_logistics_day,
        contract_status,
        earnest_url,
        earnest_money,
        logistics_manage_areas,
      } = data;
      const { logistics_bank } = JSON.parse(JSON.stringify(data));
      // 基础数据
      const baseParams = {
        name,
        business_id,
        logistics_type,
        delivery_number,
        startTime: start_time,
        endTime: end_time,
        regional_manager_id,
        regional_user_num,
        coverage_user_num,
        stop_logistics_day,
        contract_status: contract_status.toString(),
        earnest_url,
        earnest_money,
        province_code:
          logistics_manage_areas.length > 0
            ? logistics_manage_areas[0].province_code
            : "",
        city_code:
          logistics_manage_areas.length > 0
            ? logistics_manage_areas[0].city_code
            : "",
      };
      const {
        logistics_business: { id, business_user },
      } = data;

      const upgradeData = {
        account_number: business_user?.username,
        bank_mobile: logistics_bank?.mobile,
        ...business_user,
        ...logistics_bank, // 银行
        service_mobile,
        shipment_distance,
      };
      // 将数据融入基础数据
      Object.assign(baseParams, upgradeData);
      this.logisticsBusinessId = id;
      this.businessUserId = business_user?.id;
      baseParams.business_id = business_id;
      // 将表单需要的数据赋值
      Object.keys(this.cityForm).forEach((_KEY) => {
        this.cityForm[_KEY] = baseParams[_KEY];
      });
      this.cityForm.regional_manager_id = this.cityForm.regional_manager_id
        ? this.cityForm.regional_manager_id
        : ""; // regional_manager_id 为0 的时候 修改为空
      console.log("🆒 onInitEditForm", baseParams, this.cityForm);
      this.cityForm.id = data.id;
      this.cityForm.coverage_user_num =
        Number(this.cityForm.coverage_user_num) == 0
          ? ""
          : this.cityForm.coverage_user_num;
      this.cityForm.regional_user_num =
        Number(this.cityForm.regional_user_num) == 0
          ? ""
          : this.cityForm.regional_user_num;
      this.postAjaxRegionalManagerSelectList(); // 编辑集配id 联动区域经理列表
      // 服务区域 省市区 拼接回显
      if (logistics_manage_areas.length > 0) {
        this.postAreaChildList({
          parent_code: logistics_manage_areas[0].province_code,
          level: 2,
        });
        this.postAreaChildList({
          parent_code: logistics_manage_areas[0].city_code,
          level: 3,
        });
        this.cityForm.area_list = logistics_manage_areas.map(
          (lItem) => lItem.county_code
        );
      } else {
        this.cityForm.area_list = [];
      }
      this.idcard_a =
        (baseParams?.idcard_a && [
          {
            url: baseParams.idcard_a,
          },
        ]) ||
        [];
      this.idcard_b =
        (baseParams?.idcard_b && [
          {
            url: baseParams.idcard_b,
          },
        ]) ||
        [];
      // 保证金截图
      this.earnest_url =
        (baseParams?.earnest_url && [
          {
            url: baseParams.earnest_url,
          },
        ]) ||
        [];
      this.dialogLoading = false;
    },
    /**
     * 获得开户行列表
     */
    async ajaxGetBranchList(query) {
      this.depositList = [];
      if (!query) {
        return;
      }
      this.depositLoading = true;
      const params = {
        bank_code: this.cityForm.bank_code,
        branch_name: query,
      };
      try {
        const { data } = await this.$api.general.branchList(params);
        this.depositList = data;
      } catch (err) {
        console.log("ajax branchList err", err);
      } finally {
        this.depositLoading = false;
      }
    },
    /**
     * 删除图片
     */
    onHandleDeleteFile(name) {
      if (this.closeDisable) {
        return false;
      }
      // 编辑的时候 不可修改银行信息
      if (this.isEdit && (name == "idcard_a" || name == "idcard_b")) {
        return false;
      }
      this[name] = [];
      this.cityForm[name] = "";
      this.$refs.refCityForm.validateField(name);
    },
    /**
     * 上传图片
     */
    onHandleUploadFile(options, name) {
      this.uploadLoading = true;
      // 拿到 file
      let file = options.file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // console.log(e.target.result);
        this.ajaxUploadImage(e.target.result, name, options.file.uid);
      };
    },
    /**
     * 图片路径请求
     */
    async ajaxUploadImage(img, name, uid) {
      try {
        const res = await this.$api.general.uploadImage({ file_data: img });
        // 增加uid 赋值 解决上传图片跳动问题
        this[name] = [{ url: res.data, uid }];
        this.cityForm[name] = res.data;
        if (name == "idcard_b") {
          this.postAjaxGetIdcardInfo(res.data); // 人像页ocr 识别
        }
        this.$refs.refCityForm.validateField(name);
      } catch (err) {
      } finally {
        this.uploadLoading = false;
      }
    },
    /**
     * 预览上传图片
     */
    onHandlePictureCardPreview(file) {
      const params = {
        bigImage: file.url,
        showImage: true,
      };
      this.$emit("on-show-image", params);
    },
    /**
     * 重置密码，二次确认
     */
    onHandleResetPassword() {
      this.$confirm("确定要重置密码吗？", "提示", {
        center: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        customClass: "jn-confirm-message-style",
        iconClass: "el-icon-warning",
      }).then(() => {
        this.ajaxPostResetPassword();
      });
    },
    /**
     * 重置密码请求接口
     */
    async ajaxPostResetPassword() {
      if (!this.businessUserId) {
        return;
      }
      const params = {
        business_user_id: this.businessUserId,
      };
      try {
        const res = await this.$api.general.resetPassword(params);
        console.log(res, "res==");
        this.$message.success("重置成功");
        this.newPassword = true;
        this.newPasswordText = res.data.password;
      } catch (err) {
        console.log("ajax resetPassword err", err);
      }
    },
    // 身份证人像页上传ocr 识别身份证号
    async postAjaxGetIdcardInfo(url) {
      try {
        const res = await postGetIdcardInfo({ image_url: url });
        this.cityForm.idcard_code = res.data.idcard_code;
        this.cityForm.idcard_name = res.data.idcard_name;
        console.log(res, res.data.idcard_code, this.cityForm, "res==");
      } catch (error) {
        console.log(error, "postGetIdcardInfo");
      }
    },
    // 服务区域 省市区列表
    async postAreaChildList(e) {
      try {
        const res = await postAreaChildList({
          parent_code: e.parent_code || "",
          level: e.level || "",
        });
        if (!e.level || e.level == 1) {
          this.province_list = res.data || []; // 省
        }
        if (e.level == 2) {
          this.city_list = res.data || []; // 市
        }
        if (e.level == 3) {
          this.district_list = res.data || []; // 区
        }
      } catch (error) {
        console.log(error, "postAreaChildList");
      }
    },
    // 修改省
    changeProvinceList(val) {
      console.log(val, "postAreaChildList==");
      this.cityForm.city_code = "";
      this.cityForm.area_list = [];
      this.postAreaChildList({
        parent_code: val,
        level: 2 || "",
      });
    },
    // 修改市
    changeCityList(val) {
      console.log(val, "postAreaChildList==");
      this.cityForm.area_list = [];
      this.postAreaChildList({
        parent_code: val,
        level: 3 || "",
      });
    },
    // 新增 -修改城市仓类型 联动停仓整改
    changeLogisticsType(val) {
      console.log(val, "val==");
      this.cityForm.stop_logistics_day =
        this.cityForm.logistics_type == LOGISTICS_TYPE_ENUM.common.value
          ? LOGISTICS_TYPE_ENUM.common.day
          : LOGISTICS_TYPE_ENUM.member.day;
    },
    /**
     * 确认
     */
    onHandleSubmit() {
      this.$refs.refCityForm.validate((valid) => {
        if (!valid) {
          return;
        }
        /** 触发提交前校验对象 */
        const validObject = {
          startTime: {
            valid: !this.cityForm.startTime,
            message: "请选择开始时间",
          },
          endTime: {
            valid: !this.cityForm.endTime,
            message: "请选择结束时间",
          },
        };
        // 循环校验对象
        Object.values(validObject).forEach((item) => {
          if (item.valid) {
            this.$message.error(item.message);
            return;
          }
        });
        this.submitLoading = true;
        if (this.isEdit) {
          this.ajaxPostUpdateLogistics();
        } else {
          this.ajaxPostAddLogistics();
        }
      });
    },
    /**
     * 新增城市仓
     */
    async ajaxPostAddLogistics() {
      console.log(this.cityForm, "this.cityForm==");
      const { startTime, endTime } = this.cityForm;
      const params = {
        ...this.cityForm,
        truncation_time: {
          start_time: startTime,
          end_time: endTime,
        },
      };
      delete params.startTime;
      delete params.endTime;
      try {
        await this.$api.general.addLogistics(params);
        this.$message.success("新增成功");
        this.onHandleClose();
        this.$emit("on-refresh-list");
      } catch (err) {
        console.log("ajax addLogistics err", err);
      } finally {
        this.submitLoading = false;
      }
    },
    /**
     * 编辑城市仓
     */
    async ajaxPostUpdateLogistics() {
      const { startTime, endTime } = this.cityForm;
      const params = {
        ...this.cityForm,
        logistics_business_id: this.logisticsBusinessId,
        truncation_time: {
          start_time: startTime,
          end_time: endTime,
        },
      };
      delete params.startTime;
      delete params.endTime;
      console.log("🆒 ajaxPostUpdateLogistics params", params);
      try {
        await this.$api.general.updateLogistics(params);
        this.$message.success("修改成功");
        this.onHandleClose();
        this.$emit("on-refresh-list");
      } catch (err) {
        console.log("ajax updateLogistics err", err);
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.distance-style {
  width: 80%;
}
</style>
